export const financialFacilities = (state) => state.financialFacilities
